module.exports = __webpack_public_path__ + "static/media/promo_1_pic_2.2a07d8c9.svg";